import React, { ReactElement, SVGProps } from "react";
import BaseIcon from "./BaseIcon";

export default function FilePDFIcon(props: SVGProps<any>): ReactElement {
  return (
    <BaseIcon {...props}>
      <path
        d="M20.813 14.25a.563.563 0 0 1-.563.563h-2.438v1.875H19.5a.563.563 0 1 1 0 1.125h-1.688V19.5a.563.563 0 1 1-1.125 0v-5.25a.563.563 0 0 1 .563-.563h3a.563.563 0 0 1 .563.563M8.438 16.125A2.44 2.44 0 0 1 6 18.563h-.937v.937a.563.563 0 1 1-1.125 0v-5.25a.563.563 0 0 1 .563-.563h1.5a2.44 2.44 0 0 1 2.438 2.438m-1.125 0A1.313 1.313 0 0 0 6 14.813h-.937v2.625H6a1.313 1.313 0 0 0 1.313-1.313m7.875.75A3.19 3.19 0 0 1 12 20.063h-1.5a.563.563 0 0 1-.563-.563v-5.25a.563.563 0 0 1 .563-.563H12a3.19 3.19 0 0 1 3.188 3.188m-1.125 0A2.063 2.063 0 0 0 12 14.813h-.938v4.125H12a2.063 2.063 0 0 0 2.063-2.063M3.938 10.5V3.75A1.313 1.313 0 0 1 5.25 2.438h9a.56.56 0 0 1 .398.165l5.25 5.25a.56.56 0 0 1 .164.398v2.25a.563.563 0 1 1-1.125 0V8.813H14.25a.563.563 0 0 1-.563-.563V3.563H5.25a.19.19 0 0 0-.188.188v6.75a.563.563 0 1 1-1.125 0m10.875-2.813h3.33l-3.33-3.33z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
